import { Component, OnInit, forwardRef } from "@angular/core";
import {
    ControlValueAccessor,
    NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { Observable } from "rxjs";
import { switchMap } from "rxjs/operators";

@Component({
    selector: "app-typeahead-oggetto-nota",
    templateUrl: "./type-ahead-oggetto-nota.component.html",
    styleUrls: ["./type-ahead-oggetto-nota.component.scss"],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TypeAheadOggettoNotaComponent),
            multi: true,
        },
    ],
})
export class TypeAheadOggettoNotaComponent implements ControlValueAccessor, OnInit {
    public selectedValue: string = '';
    public isLoading: boolean = false;
    public showNoResults: boolean = false;
    public dataSource: Observable<string[]>;

    // Static suggestion data
    private static readonly OGGETTO_SUGGESTIONS: string[] = [
        // "Liquidazione spese per procedura di rendicontazione Fondo Sociale Europeo - Programma Operativo Regionale 2021-2027 - Asse prioritario III - Obiettivo specifico k) - CUP: [CUP_CODE] - CIG: [CIG_CODE]",
        // "Liquidazione compensi per attività di formazione professionale - Avviso pubblico per la realizzazione di percorsi formativi - Decreto Dirigenziale n. [DD_NUMBER] del [DATE] - Codice progetto: [PROJECT_CODE]",
        // "Liquidazione rimborsi spese di trasferta per attività di controllo e monitoraggio progetti FSE - Missione presso [LOCATION] - Periodo: [DATE_RANGE] - Autorizzazione n. [AUTH_NUMBER]"
    ];

    // ControlValueAccessor implementation
    onChange: any = () => { };
    onTouched: any = () => { };

    constructor() {
        // Initialize the Observable data source for typeahead following existing pattern
        this.dataSource = new Observable<string>((observer: any) => {
            observer.next(this.selectedValue);
        }).pipe(
            switchMap((value: string) => {
                const filteredSuggestions = this.filterSuggestions(value);
                return new Observable<string[]>(observer => {
                    observer.next(filteredSuggestions);
                    observer.complete();
                });
            })
        );
    }

    ngOnInit() { }

    // ControlValueAccessor methods
    writeValue(value: any): void {
        this.selectedValue = value || '';
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    onBlur(): void {
        this.onTouched();
    }

    // Suggestion filtering logic
    private filterSuggestions(query: string): string[] {
        if (!query || query.length < 3) {
            return [];
        }

        return TypeAheadOggettoNotaComponent.OGGETTO_SUGGESTIONS.filter(suggestion =>
            suggestion.toLowerCase().includes(query.toLowerCase())
        );
    }

    // Update suggestions based on input
    onInputChange(value: string): void {
        this.selectedValue = value;
        this.onChange(value);
    }

    // Typeahead event handlers
    onLoadingChange(isLoading: boolean): void {
        this.isLoading = isLoading;
    }

    onNoResults(noResults: boolean): void {
        this.showNoResults = noResults;
    }

    onSelect(event: any): void {
        if (event && event.item) {
            this.selectedValue = event.item;
            this.onChange(event.item);
            this.onTouched();
        }
    }

    // Highlight matching text in suggestions
    highlightMatch(text: string, query: string): string {
        if (!query || query.length < 3) {
            return text;
        }

        const regex = new RegExp(`(${query})`, 'gi');
        return text.replace(regex, '<strong>$1</strong>');
    }
}
